/* global Units, Departments, Emails, gon, Qforms */

import Appropriate from 'lib/appropriate'
import { FormSerializer } from 'form-serializer/jquery.serialize-object'
import 'lib/emails'
import RequestersFilter from 'lib/requesters_filter'
import 'lib/units'
import 'lib/departments'
import { post } from '@rails/request.js'
import { AjaxAutoSelect2Initialize } from 'auto_select2/ajax_select2'

window['positions#new'] = function () {
  Units.departmentsSelect()
  Units.addressesSelect()
  Departments.addressesSelect()
  Emails.initTemplateSelect()
  positionLocationsFilter(gon)
  buildForm()
}

window['positions#clone'] = window['positions#new']

window['positions#edit'] = window['positions#new']

window['positions#appropriate'] = function () {
  const form = $('#fill-position')
  // Appropriate is a class that requires a new call,
  // it initializes itself on the form
  // eslint-disable-next-line no-new
  new Appropriate({
    formSelector: form,
    onCandidateCheck: (checkedCount) => {
      $('[type="submit"]', form).attr('disabled', !checkedCount)
    }
  })
}

const positionBuildFormTriggerSelectors = [
  '#position_employment_mode',
  '#position_department_id',
  '#position_cost_center_id',
  '#position_payroll_type'
]

function buildForm () {
  $.extend(FormSerializer.patterns, { fixed: /^$/ })

  Qforms.initHints()

  $(document).on('change', positionBuildFormTriggerSelectors.join(', '), function (e) {
    buildFormRequest(this, e)
  })

  const receiversFilter = new RequestersFilter()
  receiversFilter.filter($('#position_client_company_id').val())
  $(document).on('change', '#position_client_company_id', function (e) {
    receiversFilter.filter($(e.target).val())
  })

  $(document).on('change', '#position_planned', function (e) {
    buildFormRequest(this, e)
  })
}

function positionLocationsFilter (data) {
  if (data.sp_premium) {
    $(document).on('change', '#position_client_company_id', function (e) {
      const client = $('#position_client_company_id')
      const locations = $('#position_address_ids')

      locations.prop('disabled', true)
      $('#s2id_position_address_ids .select2-choices').addClass('ui-autocomplete-loading')

      $.get(`/client_companies/${client.val()}/locations`, function (data) {
        locations.select2('val', '')
        locations.html('')
        $.each(data, (i, value) => locations.append($('<option>').text(value.name).attr('value', value.id)))

        locations.prop('disabled', false)
        $('#s2id_position_address_ids .select2-choices').removeClass('ui-autocomplete-loading')
      })
    })
  }
}

async function buildFormRequest (element, e) {
  const data = $(element).parents('form').serializeObject()
  const positionData = gon.address_ids ? Object.assign(data.position, { address_ids: gon.address_ids }) : data.position

  const response = await post(
    '/positions/build_form',
    {
      body: {
        position_id: $('#position_id').val(),
        position: positionData,
        target: e.target.id
      },
      responseKind: 'script'
    }
  )

  if (response.ok) {
    AjaxAutoSelect2Initialize() // init client company select box
  }
}
